import {persistReducer} from "redux-persist";
import storage from "redux-persist/lib/storage";
import {put, takeLatest} from "redux-saga/effects";
import {getUserByToken} from "./authCrud";
import {fixUserDataForApp} from "../../Admin/_redux/users/usersActions";

export const actionTypes = {
    Login: "[Login] Action",
    Logout: "[Logout] Action",
    UserLogged: "[User Logged] Action",
    UserRequested: "[Request User] Action",
    UserLoaded: "[Load User] Auth API"
};

const initialAuthState = {
    user: undefined,
};

export const reducer = persistReducer(
    {storage, key: "fdd-auth-v1", whitelist: ["user"]},
    (state = initialAuthState, action) => {
        switch (action.type) {

            case actionTypes.Login: {
                return { user: undefined};
            }

            case actionTypes.UserLogged: {
                return { user: undefined};
            }



            case actionTypes.Logout: {
                // TODO: Change this code. Actions in reducer aren't allowed.
                return initialAuthState;
            }

            case actionTypes.UserLoaded: {
                return {...state, user: action.payload.user};
            }


            default:
                return state;
        }
    }
);

export const actions = {
    logout: () => ({type: actionTypes.Logout}),
    requestUser: user => ({type: actionTypes.UserRequested, payload: {user}}),
    fulfillUser: user => ({type: actionTypes.UserLoaded, payload: {user}}),
    userLogged: () => ({type: actionTypes.UserLogged,}),
};

export function* saga() {
    yield takeLatest(actionTypes.UserLogged, function* loginSaga() {
        yield put(actions.requestUser());
    });

    yield takeLatest(actionTypes.UserRequested, function* userRequested() {
        try {
            const {data} = yield getUserByToken();

            const user = fixUserDataForApp(data);

            yield put(actions.fulfillUser(user));
        } catch (error) {
            console.error("Failed to load user profile:", error);
            yield put(actions.logout());
        }
    });
}
